import { jsxs as t, jsx as a } from "@emotion/react/jsx-runtime";
import r from "prop-types";
import { keyframes as c, css as n } from "@emotion/react";
import { COLORS as d } from "../../constants.mjs";
const l = c`
    100% {
        transform: rotate(360deg);
    }
    `, m = (e) => n`
    border-left-color: ${e || "inherit"};
    border-top-color: ${e || "inherit"};
`, f = (e) => {
  const o = typeof e == "number" ? e + "px" : e;
  return n`
        width: ${o};
        height: ${o};
    `;
}, i = {
  container: n`
        align-items: center;
        display: flex;
        height: 100%;
        justify-content: center;
        width: 100%;
    `,
  spinner: n`
        animation: ${l} 0.5s linear 0s infinite normal both running;
        background: transparent;
        border-color: transparent;
        border-radius: 100%;
        border-style: solid;
    `,
  hiddenText: n`
        visibility: hidden;
    `
}, h = ({ children: e, color: o, size: s, ...p }) => /* @__PURE__ */ t("span", { css: i.container, ...p, children: [
  /* @__PURE__ */ a(
    "span",
    {
      css: [
        i.spinner,
        m(o),
        f(s),
        e ? n`
                          position: absolute;
                      ` : n`
                          position: static;
                      `
      ]
    }
  ),
  e && /* @__PURE__ */ t("span", { css: i.hiddenText, children: [
    e,
    " "
  ] })
] });
h.propTypes = {
  size: r.oneOfType([r.string, r.number]).isRequired,
  color: r.oneOf(Object.values(d)),
  children: r.node,
  className: r.string
};
export {
  h as Spinner
};
